<template>
  <div class="text-input">
    <div v-show="is_edit" class="input-group">
      <input ref="input" class="form-control" type="text" :value="value"  @blur="closeEdit" @input="updateValue($event.target.value)" >
    </div>
    <div v-show="!is_edit" class="text" @click="focusInput" >{{value?value:'&nbsp'}}</div>
  </div>
</template>

<script>
  export default {
    name: "text-input",
    props: {
      value: [String,Number,Array]
    },
    mounted() {
      this.inputVal = this.value
    },
    data() {
      return {
        is_edit: false
      }
    },
    methods: {
      updateValue(value) {
        this.$emit('input', value)
      },
      focusInput(){
        this.is_edit=true;
        this.$nextTick(()=>{
          this.$refs.input.focus();
        });
      },
      closeEdit(){
        this.is_edit=false;
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>
  .text-input{
  }
  .form-control{
    text-align: center;

  }
 .text{
   padding: 0.375rem 1rem;
   font-size: 1rem;
   line-height: 1.5;
   text-align: center;
   border-bottom: 1px dashed ;
 }
</style>



// WEBPACK FOOTER //
// src/view/subSystem/text-input.vue